const routes = [
  {
    path: '/planning/triggers/:date?',
    props: true,
    component: () => import('@/views/planning/trigger/Triggers.vue')
  },
  {
    path: '/planning/trigger/:triggerId/:nav?/:page?',
    props: true,
    component: () => import('@/views/planning/trigger/Trigger.vue')
  }
]

export default routes
